var map = {
	"./about_mission_vision.jpg": 2894,
	"./astrorei-cta.jpg": 2283,
	"./astrorei-team-sviluppatori-software.jpg": 9942,
	"./authors/alexandru-david.jpg": 8861,
	"./authors/andrea-bellomia.jpg": 9101,
	"./authors/bajram-hushi.jpg": 6786,
	"./authors/carlo-vassallo.jpg": 1070,
	"./authors/davide-cerato.jpg": 8466,
	"./authors/kristian-notari.jpg": 1129,
	"./authors/lorenzo-beccaro.jpg": 5216,
	"./authors/michael-andolino.jpg": 4932,
	"./authors/valerio-buzzelli.jpg": 8078,
	"./bigData.jpg": 5547,
	"./blog/2024-img-articolo-dicembre1.jpg": 4681,
	"./blog/2024-img-articolo-dicembre2-1.jpg": 1683,
	"./blog/2024-img-articolo-dicembre2.jpg": 6149,
	"./blog/2024-img-articolo-novembre1.jpg": 5914,
	"./blog/2024-img-articolo-novembre2.jpg": 5039,
	"./blog/5-applicazioni-machine-learning-aziende.jpg": 5252,
	"./blog/L'Architettura-a-Microservizi.jpg": 4044,
	"./blog/PWAs-VS-APPN.jpg": 3062,
	"./blog/Progressive-Web-Apps.jpg": 6805,
	"./blog/Uso-del-Cloud.jpg": 4786,
	"./blog/agile-development-orangeloop.jpg": 4048,
	"./blog/agile-devops.jpg": 7007,
	"./blog/angular-sviluppo-custom.jpg": 8845,
	"./blog/angular-vue-flutter-quale-scegliere-app-personalizzate.jpg": 9046,
	"./blog/app-cross-platform-vantaggi-per-aziende-orangeloop.jpg": 377,
	"./blog/app-mobile-custom-vantaggi-svantaggi.jpg": 2306,
	"./blog/app-native-ibride-web-vantaggi-svantaggi.jpg": 2202,
	"./blog/applicazioni-ar-vr-ecommerce.jpg": 9794,
	"./blog/applicazioni-cross-platform-vantaggi-per-aziende-orangeloop.jpg": 7833,
	"./blog/astrorei-come-migliorare-lavoro-da-remoto-consigli-per-developers.jpg": 21,
	"./blog/astrorei-sviluppo-software-in-outsourcing-quale-modalità-scegliere.jpg": 2359,
	"./blog/backend-per-iot.jpg": 5120,
	"./blog/big-data-business-intelligence-sfruttare-i-dati.jpg": 2060,
	"./blog/business-intelligence-data-analysis-cover.jpg": 1775,
	"./blog/business-intelligence-data-analysis.jpg": 2129,
	"./blog/chatgpt-python.jpg": 546,
	"./blog/creare-connessioni-importanza-network.jpg": 4899,
	"./blog/creare-mvp-vincente.jpg": 1886,
	"./blog/cultura-aziendale-positiva.jpg": 1714,
	"./blog/devops-i-vantaggi-nello-sviluppo.jpg": 6557,
	"./blog/differenza-backend-frontend-fullStack-iceberg.jpg": 2534,
	"./blog/fasi-della-metodologia-devops-orangeloop.jpg": 1706,
	"./blog/flessibilita-sul-lavoro.jpg": 2970,
	"./blog/flutter-sviluppo-custom.jpg": 5516,
	"./blog/formazione-aziendale-perche-e-importante.jpg": 4221,
	"./blog/frontend-backend-full-stack-developer-differenze-orangeloop.jpg": 9332,
	"./blog/hackathon-cose-come-funziona-per-sviluppatori-astrorei.jpg": 7728,
	"./blog/human-augmentation.jpg": 7588,
	"./blog/img-articolo-ottobre1.jpg": 5594,
	"./blog/img-articolo-ottobre2.jpg": 4856,
	"./blog/img_articolo_settembre1.jpg": 2923,
	"./blog/img_articolo_settembre2.jpg": 5668,
	"./blog/implementare-blockchain.jpg": 7530,
	"./blog/lifelong-learning-programmatori-cos'è-perché-Importante.jpg": 2640,
	"./blog/low-code-development-cose-vantaggi-migliori-piattaforme.jpg": 7702,
	"./blog/low-code_Astrorei.jpg": 1930,
	"./blog/metaverso-cosa-rappresenta-per-gli-sviluppatori-orangeloop.jpg": 9859,
	"./blog/migliori-framework-app-cross-platform-orangeloop.jpg": 9380,
	"./blog/migliori-strumenti-per-business-intelligence.jpg": 2886,
	"./blog/minimum-viable-product-come-puo-ridurre-rischi-azienda-astrorei.jpg": 3555,
	"./blog/mvp-minimum-viable-product-cos-e-perche-e-fondamentale-orangeloop.jpg": 194,
	"./blog/orangeloop-analisi-dati-come-prendere-decisioni-aziendali-strategiche.jpg": 8222,
	"./blog/orangeloop-big-data-analytics-come-migliorare-performance-applicazioni-aziendali.jpg": 9767,
	"./blog/orangeloop-code-refactoring-nell-agile-tutti-i-vantaggi.jpg": 1862,
	"./blog/orangeloop-intelligenza-artificiale-sviluppo-software.jpg": 8857,
	"./blog/orangeloop-migliorare-life-work-balance-guida-per-sviluppatori.jpg": 1442,
	"./blog/orangeloop-migliore-ide-python-come-sceglierlo.jpg": 1619,
	"./blog/outsourcing-o-sviluppo-in-house-quale scegliere.jpg": 8412,
	"./blog/perche-scegliere-sviluppo-software-personalizzato.jpg": 6256,
	"./blog/pwa-trend-sviluppo-software.jpg": 3862,
	"./blog/pwa-vs-native.jpg": 5866,
	"./blog/pycharm-cose-perche-sceglierlo.jpg": 7804,
	"./blog/serverless-vantaggi-svantaggi.jpg": 6561,
	"./blog/sprint_metodologia_di_sviluppo_agile_orangeloop.jpg": 6498,
	"./blog/step-selezione-astrorei.jpg": 4572,
	"./blog/sviluppare-con-react-vantaggi-aziende-orangeloop.jpg": 2322,
	"./blog/sviluppo-low-code-trasformazione-digitale.jpg": 7078,
	"./blog/sviluppo-software-10-trend-2024.jpg": 1696,
	"./blog/system-integration-perche-importante-per-aziende-orangeloop.jpg": 4039,
	"./blog/team-working-azienda-perche-importante.jpg": 6034,
	"./blog/tecnologia-blockchain.jpg": 1550,
	"./blog/ten-growing-trends-part-2.jpg": 75,
	"./blog/ux-ui-and-programming-development-technology.jpg": 8131,
	"./blog/vue-sviluppo-custom.jpg": 4746,
	"./consulenza-strategica-per-aziende-astrorei.jpg": 6811,
	"./custom-software-sviluppo-su-misura-astrorei.jpg": 9926,
	"./desktopApp.jpg": 7925,
	"./dev_hero.jpg": 1942,
	"./devops.jpg": 3813,
	"./dotnetDev.jpg": 3174,
	"./experts/bajram.jpg": 1254,
	"./experts/carlo.jpg": 1627,
	"./experts/davide.jpg": 8133,
	"./experts/emanuele.jpg": 4234,
	"./experts/kristian.jpg": 1302,
	"./experts/lorenzo.jpg": 3258,
	"./experts/michael.jpg": 2240,
	"./experts/valerio.jpg": 7159,
	"./experts/vishal.jpg": 1623,
	"./frontendDev.jpg": 7446,
	"./hero.jpg": 5021,
	"./home_service_1.jpg": 9466,
	"./home_service_2.jpg": 2266,
	"./iot.jpg": 1511,
	"./javaDev.jpg": 2810,
	"./join.jpg": 1231,
	"./lavora-con-noi-astrorei.jpg": 8992,
	"./mobileApp.jpg": 605,
	"./mvp.jpg": 6901,
	"./napoleon_hill.jpg": 983,
	"./nodejsDev.jpg": 960,
	"./orangeloop-27.jpg": 7705,
	"./orangeloop-29.jpg": 5134,
	"./orangeloop-32.jpg": 7467,
	"./orangeloop-34.jpg": 3436,
	"./orangeloop-37.jpg": 2976,
	"./orangeloop-52.jpg": 8243,
	"./phpDev.jpg": 1501,
	"./pythonDev.jpg": 9835,
	"./rustDev.jpg": 2064,
	"./sales-rappresentative.jpg": 7701,
	"./schumpeter.jpg": 843,
	"./systemIntegrationAutomation.jpg": 1401,
	"./team-sviluppo-dedicato-outsourcing-astrorei.jpg": 9871,
	"./team.jpg": 8718,
	"./vr.jpg": 9160,
	"./webApp.jpg": 4887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;